module.exports = __webpack_public_path__ + "static/media/vinglabs_proteus_delta.5deafc51.JPG";